import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-base-cards-info',
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './base-cards-info.component.html',
  styleUrl: './base-cards-info.component.scss'
})
export class BaseCardsInfoComponent {

}